import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setOpenIdCallBackUrl } from '../../state';
import { useLocalStorage } from 'primereact/hooks';

export const OpenIdStoreCallbackUrlHandler: FC<PropsWithChildren> = (props) => {
    const dispatch = useDispatch();
    const [localStorageCallBackUrl, setLocalStorageCallBackUrl] = useLocalStorage('', 'openIdCallBackUrl');

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const callback = queryParams.get('callback');
        if (callback) {
            setLocalStorageCallBackUrl(callback);
        }
    }, [dispatch, setLocalStorageCallBackUrl]);

    useEffect(() => {
        if (localStorageCallBackUrl) {
            dispatch(setOpenIdCallBackUrl(localStorageCallBackUrl));
        }
    }, [localStorageCallBackUrl, dispatch]);

    return (<>
        {props.children}
    </>);
};
